
import { Injectable, Inject } from '@angular/core';
import{BasePolicyPaymentDO} from './BasePolicyPayment.model';


export class GroupPolicyPaymentDO extends BasePolicyPaymentDO  {
    
     public  id:number = null;

}